import styled from "styled-components";

const TextInput = styled.input`
  display: flex;
  flex: 1;
`;

export default TextInput;
